import * as React from 'react'
import { styled } from '@design/pt-ui'

import { useDidUpdate } from '../utils/hooks'

export type Props = {
  gif: string
  still?: string
  autoplay?: boolean
  alt?: string
  className?: string
  style?: React.CSSProperties
  onTogglePlay?: (playing: boolean) => any
}

const PlayerHolder = styled('div', {
  shouldForwardProp: (prop) => prop !== 'playing',
})<{ playing: boolean }>(({ playing }) => ({
  display: 'inline-block',
  position: 'relative',
  userSelect: 'none',
  WebkitTouchCallout: 'none',
  WebkitTapHighlightColor: 'transparent',

  '& img': {
    maxWidth: '100%',
  },

  '& .play_button': {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    border: '2px dashed #fff',
    borderRadius: '50%',
    boxShadow: '0 0 0 3px rgba(0, 0, 0, 0.5)',
    color: '#fff',
    cursor: 'pointer',
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: '24px',
    left: '50%',
    padding: '14px 10px',
    position: 'absolute',
    top: '50%',
    transition: 'transform 0.4s, opacity 0.4s',
    opacity: playing ? 0.5 : 1,
    transform: playing
      ? 'translate(-50%, -50%) scale(0) rotate(180deg)'
      : 'translate(-50%, -50%) scale(1) rotate(0deg)',

    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      boxShadow: '0 0 0 3px rgba(0, 0, 0, 0.7)',
    },

    '&::after': {
      content: "'GIF'",
    },
  },
}))

export default function GifPlayer(props: Props) {
  const [playing, setPlaying] = React.useState<boolean>(Boolean(props.autoplay))

  useDidUpdate(() => {
    if (props.autoplay && props.gif) {
      setPlaying(true)
    }
  }, [props.gif])

  const toggle = () => {
    const next = !playing
    setPlaying(next)

    if (props.onTogglePlay) {
      props.onTogglePlay(next)
    }
  }

  return (
    <PlayerHolder
      playing={playing}
      className={props.className}
      onClick={toggle}>
      <div className="play_button" />
      <img
        style={props.style}
        src={playing ? props.gif : props.still || props.gif}
        alt={props.alt ?? ''}
      />
    </PlayerHolder>
  )
}
